import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {environment} from '../../../environments/environment';

import {finalize} from 'rxjs/operators';
import {AuthService} from '../../services/auth.service';
import {ToastrService} from 'ngx-toastr';
import {ApiService} from '../../services/api.service';
import {Router} from '@angular/router';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {ILaravelDataTableConfig} from '../../../../projects/xs-laravel-data-table/src/interfaces/ILaravelDataTableConfig';

@Component({
   selector: 'app-manage-top-ranker',
   templateUrl: './manage-top-ranker.component.html',
   styleUrls: ['./manage-top-ranker.component.scss']
})
export class ManageTopRankerComponent implements OnInit {
   @ViewChild('addNew') addNewModal;
   @ViewChild('table') table;
   public formErrors;
   public selectedItem;
   public endpoint = environment.endpoint + 'admin/top-ranker/list';
   public tableConfig: ILaravelDataTableConfig = {
      fields: [
         {name: 'ID', key: 'id', type: 'text', width: 'min'},
         {name: 'Name', key: 'ranker_name', type: 'text',},
         {name: 'Position', key: 'rank_position', type: 'text',},
         {name: 'Exam', key: 'exam_name', type: 'text',},
         {name: 'Created', key: 'created_at', type: 'dateIST'},
         {name: 'Status', key: 'status', type: 'text', width: 'min',},
         {name: 'Sort', key: 'sort_order', type: 'sort', width: 'min'},
      ]
   }; //
   public form: UntypedFormGroup;
   public pageForm: UntypedFormGroup;
   public categories = [];

   constructor(public toastr: ToastrService,
               public api: ApiService,
               public auth: AuthService,
               public router: Router,
               public modal: NgbModal,
               public loader: NgxUiLoaderService) {
      this.form = new UntypedFormGroup({
         id: new UntypedFormControl(),
         ranker_name: new UntypedFormControl(),
         ranker_img: new UntypedFormControl(),
         status: new UntypedFormControl('publish'),
         rank_position: new UntypedFormControl(),
         exam_name: new UntypedFormControl(),
         sort_order: new UntypedFormControl(),
         categories: new UntypedFormControl(),
      });
      this.pageForm = new UntypedFormGroup({
         id: new UntypedFormControl(),
         bdrt: new UntypedFormControl()
      });

      this.api.post('admin/top-ranker-category/all', {})
         .pipe(finalize(() => this.loader.stop()))
         .subscribe((res: any) => {
            this.categories = res;
         })
   }

   ngOnInit() {
      this.loadPage();
   }

   add(addNew: TemplateRef<any>) {
      this.selectedItem = null;
      this.form.reset();
      this.modal.open(addNew);
   }

   save() {
      this.loader.start();
      this.api.post('admin/top-ranker/save', this.form.value)
         .pipe(finalize(() => {
            this.loader.stop();
         }))
         .subscribe((res: any) => {
            this.modal.dismissAll();
            this.table.loadData();
         }, (e) => {
            this.formErrors = e.errors;
         });
   }

   saveBdrt() {
      this.loader.start();
      this.api.post('admin/page/save', this.pageForm.value)
         .pipe(finalize(() => {
            this.loader.stop();
         }))
         .subscribe((res: any) => {
            this.modal.dismissAll();
         });
   }

   loadPage() {
      this.loader.start();
      this.api.get('admin/page/46', {})
         .pipe(finalize(() => {
            this.loader.stop();
         }))
         .subscribe((res: any) => {
            this.pageForm.patchValue(res);
         });
   }

   edit(item, index) {
      this.selectedItem = item;
      this.form.patchValue(this.selectedItem);
      this.form.patchValue({categories: item.categories.map((e) => e.id)});
      const modalRef = this.modal.open(this.addNewModal);
   }

   delete(item, index) {
      this.loader.start();
      this.api.post('admin/top-ranker/delete', {id: item.id})
         .pipe(finalize(() => {
            this.loader.stop();
         }))
         .subscribe(() => {
            this.table.removeItemAtIndex(index);
         });
   }
}
